<template>
  <div class="title-block">
    Dans quel espace souhaitez-vous restaurer la campagne ?
  </div>
  <p class="under-text">
    La campagne sera restaurée dans l’espace de votre choix avec la liste des
    talents ayant complété leur évaluation et obtenu leurs résultats.
  </p>
  <div class="input-wrapper">
    <label v-text="'Choisir l’espace dans lequel la campagne sera restaurée'" />
    <v-select
      id="campaign-space"
      placeholder="Sélectionnez l’espace"
      name="campaign-space"
      label="name"
      v-model="state.space"
      :clearable="false"
      :options="spaceStore.companySpaces"
    >
      <template v-slot:no-options="{ search, searching }">
        <div style="padding: 8px 0">
          Pas de résultat {{ searching ? ` pour ${search}` : "" }}.
        </div>
      </template>
    </v-select>
  </div>
  <div class="btn-container">
    <Button
      class="secondary outline"
      label="Annuler l’opération"
      @click="emits('close')"
    />
    <Button
      class="primary"
      label="Restaurer la campagne"
      :loading="state.btnIsLoading"
      :disabled="!state.space"
      @click="restore"
    />
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";
import { useCampaignStore } from "@/stores/campaign.js";
import { useSpaceStore } from "@/stores/space.js";
import ToastContent from "@/components/global/ToastContent.vue";

const emits = defineEmits(["close", "confirm"]);

const campaignStore = useCampaignStore();

const spaceStore = useSpaceStore();

const route = useRoute();

const toast = useToast();

const state = reactive({
  btnIsLoading: false,
  space: null,
});

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

async function restore() {
  state.btnIsLoading = true;

  const resp = campaignStore.restoreCampaign(
    route.params.companyId,
    state.space.workspace_id,
    props.data.campaign.campaign_id
  );

  if (!resp.code) {
    toast.success({
      component: ToastContent,
      props: {
        text: `La campagne <span class="bold">${props.data.campaign.name}</span> a bien été restaurée vers l’espace <span class="bold">${state.space.name}</span>`,
      },
      closeOnClick: false,
    });
  } else {
    toast.error(getError(resp.key));
  }

  emits("confirm");

  state.btnIsLoading = false;
}
</script>
